import io from './io';

export const isSignSession = (pathname) =>
    pathname.slice(0, 15) === '/sign-sessions/';

export const getIsSharedDocumentView = (pathname) =>
    pathname.split('/')[1] === 'shared-document-view';

export const createSignSession = (data) => {
    return io.post('/sign-sessions', data, true);
};

export const getSignSessionId = () => {
    try {
        const { pathname } = location;
        if (isSignSession(pathname) || getIsSharedDocumentView(pathname)) {
            return pathname.split('/')[2];
        }
    } catch (_) {
        return null;
    }
    return null;
};

export const prepareSignSessionOptions = () => {
    const signSessionId = getSignSessionId();
    if (!signSessionId) {
        return {};
    }
    return {
        headers: {
            'X-SignSession-ID': signSessionId,
        },
    };
};

/**
 * Add Sign-Session credentials into headers
 * @param {RequestInit} init
 */
export const decorateRequestInitWithSignSessionCredentials = (init) => {
    const signSession = prepareSignSessionOptions();

    if (signSession.headers) {
        if (!init.headers) {
            init.headers = {};
        }

        init.headers = { ...init.headers, ...signSession.headers };
    }
};

export const finishSignSession = async (finishUrl) => {
    const { url } = await io.post(
        finishUrl,
        {},
        true,
        prepareSignSessionOptions(),
    );
    return url;
};

export default {
    finishSignSession,
    getSignSessionId,
    prepareSignSessionOptions,
};
